/**
 * Codmon Checkboxディレクティブ
 *
 * @description
 * デザインシステムの Checkbox コンポーネントに対応するチェックボックスを提供します。
 * ng-model による双方向バインドと、checked（表示状態を親が算出する制御用）の
 * 2 通りの使い方ができます。
 *
 * @example
 * // ng-model で状態を持つ
 * <codmon-checkbox ng-model="form.agree" size="medium">利用規約に同意する</codmon-checkbox>
 *
 * @example
 * // 表示状態を親が算出し、クリック時の処理を親に委ねる（一括選択など）
 * <codmon-checkbox checked="isAllSelected()" on-change="toggleAll(checked)">すべて選択</codmon-checkbox>
 *
 * @example
 * // ラベルなし
 * <codmon-checkbox ng-model="row.selected" aria-label="行を選択"></codmon-checkbox>
 *
 * @property {boolean} [ngModel] - チェック状態（双方向バインド）
 * @property {boolean} [checked] - チェック状態（片方向。ng-model と併用しない）
 * @property {boolean} [ngDisabled=false] - 無効化状態
 * @property {string} [size="medium"] - サイズ (small, medium)
 * @property {string} [name] - input要素のname属性
 * @property {string} [testId] - input要素の data-test 属性
 * @property {string} [ariaLabel] - ラベルなしで使う場合のアクセシブルネーム
 * @property {Function} [onChange] - クリックで状態が変わるときに呼ばれる。引数 `checked` に変更後の値が入る
 * @property {boolean} [isNewPrimaryColor=false] - 新プライマリカラー（#017DBC）を使用するか（デフォルト: 旧CoDMON Blue #01A2C1）
 * @transclude ラベルテキスト
 */
angular.module('inspinia').directive('codmonCheckbox', [
  '$timeout',
  ($timeout) => ({
    restrict: 'E',
    transclude: true,
    scope: {
      ngModel: '=?',
      checked: '=?',
      ngDisabled: '=?',
      size: '@',
      name: '@',
      testId: '@',
      ariaLabel: '@',
      onChange: '&?',
      isNewPrimaryColor: '=?',
    },
    templateUrl: `/manage/src/view/directive/codmon-ui/codmon_checkbox.html?${new Date().getTime()}`,
    link($scope, element, attrs) {
      const sizes = ['small', 'medium'];
      $scope.size = sizes.includes($scope.size) ? $scope.size : 'medium';
      $scope.inputId = `codmon-checkbox-${$scope.$id}`;

      // ng-model が指定されていればそちらを正、なければ checked を正とする
      const usesModel = angular.isDefined(attrs.ngModel);
      const input = element.find('input');

      $scope.isChecked = () => (usesModel ? !!$scope.ngModel : !!$scope.checked);

      // 算出値と DOM の checked を同期する。
      // ネイティブのクリックで DOM 側が先に反転するため、親が変更を反映しなかった場合も算出値に戻す
      const syncDom = () => {
        input.prop('checked', $scope.isChecked());
      };
      $scope.$watch($scope.isChecked, syncDom);

      $scope.onClickInput = () => {
        if ($scope.ngDisabled) return;
        const next = !$scope.isChecked();
        if (usesModel) $scope.ngModel = next;
        if ($scope.onChange) $scope.onChange({ checked: next });
        $timeout(syncDom, 0, false);
      };

      $scope.checkboxClasses = () => ({
        [`codmon-checkbox--${$scope.size}`]: true,
        'codmon-checkbox--disabled': !!$scope.ngDisabled,
        'codmon-checkbox--new-primary-color': !!$scope.isNewPrimaryColor,
      });
    },
  }),
]);
